<template>
    <li
        class="mb-4 pl-16 text-right"
    >
        <div class="text-sm text-gray-600">
            <strong>{{ md.scheduled_send_time }}</strong>
        </div>
        <div v-if="md.media && Array.isArray(md.media)">
            <div v-for="url in md.media"
                    class="flex flex-row"
                    :class="{ 'justify-start' : md.type === 'incoming', 'justify-end' : md.type !== 'incoming' }">
                <img :src="url" class="max-w-xs rounded-lg my-2" />
            </div>
        </div>
        <div v-if="md.media && !Array.isArray(md.media)">
            <div class="flex flex-row"
                    :class="{ 'justify-start' : md.type === 'incoming', 'justify-end' : md.type !== 'incoming' }">
                <img :src="md.media" class="max-w-xs rounded-lg my-2" />
            </div>
        </div>
        <div
            v-if="md.unparsed_message"
            class="inline-block py-2 px-4 rounded-lg text-white font-bold bg-blue-600"
        >
            {{ md.unparsed_message }}
        </div>
    </li>
</template>
<script>
    export default {
        props: {
            md: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        methods: {
        },
        computed: {
        },
    }
</script>

<style scoped>
</style>
